import { Alert, Slide, Snackbar } from '@mui/material';
import { fontSize, size } from '@styles/theme';
import parseError from '@utils/parseError';
import { createContext, useState, useContext, useRef } from 'react'

const SnackBarComponent = ({ message, kind='success' }) => {
  const [isOpen, setIsOpen] = useState(true)
  const styles = {
    success: {
      backgroundColor: '#0C130D',
      color: '#CCE8CD',
    },
    info: {
      backgroundColor: '#071318',
      color: '#B8E7FB'
    },
    warning: {
      backgroundColor: '#191207',
      color: '#FFE2B7'
    },
    error: {
      backgroundColor: '#160B0B',
      color: '#F4C7C7'
    },
  }

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{ backgroundColor: 'transparent' }}
      onClose={() => setIsOpen(false)}
      TransitionComponent={Slide}
    >
      <Alert
        // variant="outlined"
        severity={kind}
        sx={{ width: '100%' }}
        style={{
          width: '90dvw',
          minHeight: size(8),
          borderRadius: 10,
          fontSize: fontSize('md'),
          marginTop: size(2),
          display: 'flex',
          alignItems: 'center',
          'MuiAlert-action': { padding: 0 },
          ...(styles[kind] || styles['success'])
        }}
        onClose={() => setIsOpen(false)}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

const SnackBarContext = createContext();
const SnackBarProvider = ({ children }) => {
  const [snackBars, setSnackBars] = useState([])
  const timeout = useRef(null)

  // TODO/WARNING: Snackbars don't currently stack, and it looks like we need to use another library to get that to work properly (maybe)
  // https://stackoverflow.com/questions/70328972/how-to-dynamically-create-multiple-alerts-inside-mui-v5-snackbar
  const addSnackBar = (snackState) => {
    setSnackBars((snacks) => {
      return snacks.concat(snackState)
    })
    // NOTE: The purpose of this is to reset the snack state so we're not storing too many in memory
    //       The timeout debounces when we clear the state so that getting multiple messages at the
    //       same time won't cause us to wipe the snackbars out prematurely
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      setSnackBars([])
    }, 10000)
  }

  const renderSnackBars = () => {
    return snackBars.map((snack, i) => (
      <SnackBarComponent key={i} {...snack} />
    ))
  }

  const snackError = ({ error, fallbackMessage }) => {
    return parseError({
      messageCallback: addSnackBar,
      fallbackMessage,
      error,
    })
  }

  return (
    <SnackBarContext.Provider value={{ addSnackBar, snackError }}>
      {children}
      {renderSnackBars()}
    </SnackBarContext.Provider>
  )
}

const useSnackBarContext = () => useContext(SnackBarContext)

export default useSnackBarContext

export { SnackBarContext, SnackBarProvider, useSnackBarContext }
